import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Services from "./components/Services/Services";
import Reception from "./components/Reception/Reception";
import Clients from "./components/Clients/Clients";
import Process from "./components/Process/Process";
import TargetClients from "./components/TargetClients/TargetClients";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

import React, { useEffect, useState } from "react";

function App() {
    const [theme, setTheme] = useState(() => {
        const savedTheme = window.localStorage.getItem("gramlich-theme");
        return savedTheme === "light" ? "light" : "dark";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        window.localStorage.setItem("gramlich-theme", theme);
    }, [theme]);

    return (
        <main className="App">
            <Navbar />
            <div className="main-pages">
                <Home />
                <Services />
                <Reception />
                <Clients />
                <Process />
                <TargetClients />
                <About />
                <Contact />
            </div>
            <Footer />
            <button
                className="theme-toggle"
                type="button"
                onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            >
                {theme === "dark" ? "Light mode" : "Dark mode"}
            </button>
        </main>
    );
}

export default App;
